import Papa from "papaparse";
import { isValidPhoneNumber } from "libphonenumber-js/min";

type ParsedAttendee = {
  fullName: string;
  email: string;
  phone?: string;
};

type ParseAttendeesCSVResult = {
  attendees: ParsedAttendee[];
  errors: string[];
};

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const normalizePhone = (value: string) =>
  value
    .replace(/\u00A0/g, " ")
    .replace(/[()\-\s]/g, "")
    .trim();

export const parseAttendeesCSV = (
  file: File,
): Promise<ParseAttendeesCSVResult> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const attendees: ParsedAttendee[] = [];
        const errors: string[] = [];

        results.data.forEach((row: any, index: number) => {
          const fullName = row["Full name"]?.trim();

          const emailRaw = row.Email?.trim();
          const email = emailRaw?.toLowerCase();

          const rawPhone = row["Phone number"];
          const phone = rawPhone ? normalizePhone(rawPhone) : undefined;

          if (!fullName || !email) {
            errors.push(`Row ${index + 2}: Missing name or email`);
            return;
          }

          if (!EMAIL_REGEX.test(email)) {
            errors.push(`Row ${index + 2}: Invalid email`);
            return;
          }

          if (phone && !isValidPhoneNumber(phone)) {
            errors.push(`Row ${index + 2}: Invalid phone`);
            return;
          }

          attendees.push({
            fullName,
            email,
            ...(phone && { phone }),
          });
        });

        resolve({
          attendees,
          errors,
        });
      },
      error: (err) => reject(err.message),
    });
  });
};
